module.exports = __webpack_public_path__ + "static/img/Silver Elite Master.8a21a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Silver Elite Master.png
// module id = +Qn9
// module chunks = 38